import { computed } from 'mobx';
import { MouseEvent } from 'react';

import ContentStore from './ContentStore';
import RootStore from './RootStore';
import RouteStore from './RouteStore';

export interface Breadcrumb {
  label: string;
  current: boolean;
  url: string;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export default class BreadcrumbStore {
  private routeStore: RouteStore;
  private contentStore: ContentStore;

  constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;
    this.contentStore = rootStore.contentStore;
  }

  @computed
  get hidden() {
    return this.routeStore.currentPathIsHomepage;
  }

  @computed
  get breadcrumbs(): Breadcrumb[] {
    const currentPageContent = this.contentStore.currentPageContent;
    const breadcrumbs = (currentPageContent && currentPageContent.breadcrumbs) || [];
    const title = (currentPageContent && currentPageContent.originalTitle) || '';

    const rootBreadcrumb: Breadcrumb = {
      label: 'Telia',
      current: breadcrumbs.length === 0,
      url: this.routeStore.currentHomepagePathname,
      onClick: this.getOnClickHandler(this.routeStore.currentHomepagePathname)
    };

    const childBreadcrumbs: Breadcrumb[] = breadcrumbs.map((crumb) => {
      const url = crumb.path;

      return {
        label: crumb.anchor,
        current: crumb.anchor === title,
        url,
        onClick: this.getOnClickHandler(url)
      };
    });

    return [rootBreadcrumb, ...childBreadcrumbs];
  }

  private getOnClickHandler = (url: string) => {
    return (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      this.routeStore.push(url);
    };
  };
}
